module.exports = __webpack_public_path__ + "img/icon_2.a04bb532.png";